/* Built In Imports */

/* External Imports */
import { Box, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyImageRenderComponent from '../../components/UI/LazyImageRenderComponent';
import ProgressiveBg from '@components/UI/ProgressiveBg';
import { render } from 'datocms-structured-text-to-html-string';
import StructuredTextParser from '../../app/landing_pages/karma/Components/StructuredTextParser';

const ProgramRating = ({ pageConfig, sectionContent, lang, region }) => {
  const pageConfigVal = pageConfig?.[0]?.value;
  return (
    <Box
      backgroundImage={{
        base: pageConfigVal?.topbanner?.rating?.mob,
        sm: pageConfigVal?.topbanner?.rating?.mob,
        md:
          pageConfigVal?.topbanner?.rating?.tab ||
          pageConfigVal?.topbanner?.rating?.desktop,
        lg: pageConfigVal?.topbanner?.rating?.desktop,
        xl: pageConfigVal?.topbanner?.rating?.bigScreen,
        '2xl': pageConfigVal?.topbanner?.rating?.bigScreen,
      }}
      bgColor={'#f4f4f4'}
      backgroundRepeat="no-repeat"
      backgroundSize="cover"
      position="relative"
      h={{
        base: 'auto',
      }}
      width="100%"
      padding="5px"
      pt={{ base: '60px', md: '80px' }}
      pb={{ base: '40px', md: '80px' }}
      px={{ base: '16px', md: '0' }}
      mx="auto"
      lazyLoad
    >
      <StructuredTextParser
        str={render(sectionContent?.[0]?.body)}
        region={region}
        lang={lang}
        color={'#3B444B'}
        fontFamily={'FedraSansStd-medium'}
        fontSize={{ base: '24px', md: '40px' }}
        lineHeight={{ base: '28.8px', md: '50px' }}
        pb={{ base: '24px', md: '34px' }}
        textAlign={'center'}
        mt="0px"
      />
      {true && (
        <Box w={'max-content'} mx={'auto'}>
          <LazyImageRenderComponent
            src={sectionContent?.[1]?.image?.url}
            alt={sectionContent?.[1]?.image?.alt}
            mx="auto"
          />
        </Box>
      )}
      <StructuredTextParser
        str={render(sectionContent?.[2]?.body)}
        region={region}
        lang={lang}
        color={'#11146D'}
        fontFamily={'FedraSansStd-book'}
        fontSize={{ base: '20px', md: '28px' }}
        lineHeight={{ base: '26px', md: '36.4px' }}
        pt={'8px'}
        pb={'4px'}
        whiteSpace="pre-line"
        textAlign="center"
        mt="0px"
      />
    </Box>
  );
};

export default ProgramRating;
